/**
 * Real `@itk-wasm/morphological-contour-interpolation` (official, pre-built
 * WASM, v2.0.0, from KitwareMedical/ITKMorphologicalContourInterpolation).
 * Lazy pipeline fetch, see `downsampleClient.ts`'s header for the shared
 * notes. Fills in slices missing from a segmentation mask between labeled
 * slices -- verified against synthetic data in
 * `scripts/verify-itk-wasm-tools.mjs` (a label present on slices 0 and 4,
 * absent on 1-3, interpolates to a non-empty slice 2).
 *
 * Needs a UInt8 label image, not the Float32 scalar image
 * `niftiVolumeToItkImage` builds -- the wasm CLI throws "Unsupported image
 * type" on float32 (confirmed live in the browser 2026-10-02; the Node
 * verify script above already used `niftiVolumeToItkLabelImage`'s UInt8
 * convention correctly, this client wrapper just hadn't matched it).
 */
import { morphologicalContourInterpolation } from "@itk-wasm/morphological-contour-interpolation";

import type { NiftiVolume } from "@/lib/nifti";
import { itkImageToNiftiVolume, niftiVolumeToItkLabelImage } from "./itkImage";

export async function interpolateSegmentationSlices(labelVol: NiftiVolume): Promise<NiftiVolume> {
  const input = niftiVolumeToItkLabelImage(labelVol, "labels");
  const { outputImage } = await morphologicalContourInterpolation(input, {});
  return itkImageToNiftiVolume(outputImage);
}
